import React, { Component } from 'react'
import { connect } from 'react-redux'

import { searchAccounts } from '../../ducks/super-admin'
import { deleteAccount } from '../../ducks/organisation-admin'
import AccountList from '../AccountList'

class AccountListContainer extends Component {
  componentDidMount() {
    const { searchAccounts } = this.props

    searchAccounts(null)
  }

  handleSearch = keyword => {
    this.props.actions.search(keyword)
  }

  handleDelete = accountId => {
    this.props.deleteAccount(accountId)
  }

  render() {
    const { accounts, deletedAccountIds, currentAccount } = this.props

    return (
      <AccountList
        accounts={accounts}
        onDelete={this.handleDelete}
        deletedAccountIds={deletedAccountIds}
        onSearch={this.handleSearch}
        isSuperAdminView={true}
        currentAccount={currentAccount}
      />
    )
  }
}

export default connect(
  state => ({
    currentAccount: state.account.get('currentAccount'),
    accounts: state.superAdmin.get('accounts'),
    deletedAccountIds: state.organisationAdmin.get('deletedAccountIds')
  }),
  {
    searchAccounts,
    deleteAccount
  }
)(AccountListContainer)



// WEBPACK FOOTER //
// ./src/components/smart/AccountListContainer.js